import React from 'react'
import { Box } from '@mui/material'
import { Colors } from '../styles/theme'
import BomTableRow from './BomTableRow'

// INFO: 06/26/23 Desktop/Mobile LineItem will render 132 times per invqty update - thats 11 products with 6 cells ea. doubled under StrictMode.  That is fine.
export default function BomTable({
    bomLineItems,
    handleInputChange,
    handleValue,
    isDesktopDisplay,
    invList,
}) {
    // console.log(`In BOMTable`)

    const theRows = bomLineItems
        .sort((a, b) => a.displayOrder - b.displayOrder)
        .reduce((acc, productRow) => {
            return [
                ...acc,
                <BomTableRow
                    key={productRow.productIDNum}
                    productRow={productRow}
                    handleInputChange={handleInputChange}
                    handleValue={handleValue}
                    isDesktopDisplay={isDesktopDisplay}
                    invList={invList}
                />,
            ]
        }, [])

    return (
        <Box
            sx={{
                '& .MuiBox-root:nth-of-type(odd)': {
                    bgcolor: `${Colors.companyColors.beige}`,
                },
            }}
        >
            {theRows}
        </Box>
    )
}
